// @ts-nocheck
/*
 * PageActionsContext: lets pages register a small ReactNode of action buttons
 * that should appear inline with the dashboard topnav title (between the page
 * title and the user profile). DashboardTopNav renders whatever the current
 * page registers via setPageActions(); pages clear on unmount.
 *
 * This lives in a React context (instead of a DOM portal) so the buttons are
 * part of the same reconciliation tree as the rest of the dashboard chrome —
 * no race conditions where the portal target is missing or stale.
 */
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const PageActionsContext = createContext({
  pageActions: null,
  setPageActions: () => {},
});

export function PageActionsProvider({ children }) {
  const [pageActions, setPageActionsState] = useState(null);

  const setPageActions = useCallback((node) => {
    setPageActionsState(node);
  }, []);

  const value = useMemo(
    () => ({ pageActions, setPageActions }),
    [pageActions, setPageActions],
  );

  return (
    <PageActionsContext.Provider value={value}>
      {children}
    </PageActionsContext.Provider>
  );
}

export function usePageActions() {
  return useContext(PageActionsContext);
}
